import { type RecipientItem } from '@capsicum/common';
import { type NCWSendAssetType } from '@capsicum/socios-core';
import { atom } from 'jotai';

/**
 * This is the atom that keeps track of the asset that is being sent in the NCW Send Flow
 */
export const ncwSendAssetAtom = atom<NCWSendAssetType | undefined>(undefined);

/**
 * A decimal string with the amount of CHZ or the number of fan tokens to transfer
 */
export const ncwTransferAmountAtom = atom<string | undefined>(undefined);

/**
 * The recipient of the transfer
 */
export const ncwTransferRecipientAtom = atom<RecipientItem | undefined>(undefined);
